import clsx from 'clsx';
import React from 'react';
import AddIcon from '../../assets/icons/add-icon.svg?react';
import Input from '../Input';
import { useButtonSizeSmall } from '../../utils/buttonSizes';
import Button from '../Button';
import Select from '../Select';
import EditIcon from '../../assets/icons/edit-icon.svg?react';
import { STATES } from './contants';

interface CreateEstablishmentModalProps {
  otherClasses?: string;
  formHandler: any;
  editEstablishment: boolean;
  handleClose: () => void;
}

const CreateEstablishmentModal: React.FC<CreateEstablishmentModalProps> = ({
  otherClasses,
  formHandler,
  editEstablishment,
  handleClose,
}) => {
  const createEstablishmentModalClasses = clsx(otherClasses);

  const sm = useButtonSizeSmall();

  return (
    <div
      className={createEstablishmentModalClasses}
      data-testid="create-establishment-modal"
    >
      <div className="mb-8 flex w-full flex-col items-center gap-2.5 text-center lg:mb-12">
        {editEstablishment ? (
          <EditIcon className="[&>path]:fill-brand-byzantine h-12 w-12 md:h-85 md:w-85" />
        ) : (
          <AddIcon className="[&>path]:fill-brand-byzantine h-12 w-12 md:h-85 md:w-85" />
        )}
        <h4 className="text-brand-byzantine font-ulagadi-sans font-bold">
          {editEstablishment ? `Edit Establishment` : `Create Establishment`}
        </h4>
      </div>{' '}
      <form
        action=""
        className="flex h-full w-full flex-col"
        onSubmit={formHandler.handleSubmit}
      >
        <div className="grid w-full grid-cols-1 gap-8 sm:grid-cols-2 sm:gap-5">
          <Input
            onBlur={formHandler?.handleBlur}
            label={
              <>
                Establishment Name
                <span className="text-brand-posh-pink">*</span>
              </>
            }
            errorMessage={
              formHandler?.touched.establishmentName &&
              formHandler?.errors.establishmentName
                ? formHandler?.errors.establishmentName
                : ''
            }
            disabled={formHandler?.isSubmitting}
            value={formHandler?.values.establishmentName}
            type="text"
            placeholder="Name of establishment"
            onChange={formHandler?.handleChange}
            name="establishmentName"
            otherClasses={{ container: 'w-full' }}
          />
          <Input
            onBlur={formHandler?.handleBlur}
            label={
              <>
                Street
                <span className="text-brand-posh-pink">*</span>
              </>
            }
            errorMessage={
              formHandler?.touched.street && formHandler?.errors.street
                ? formHandler?.errors.street
                : ''
            }
            disabled={formHandler?.isSubmitting}
            value={formHandler?.values.street}
            type="text"
            placeholder="Name of street"
            onChange={formHandler?.handleChange}
            name="street"
            otherClasses={{ container: 'w-full' }}
          />
        </div>
        <div className="my-8 grid w-full grid-cols-1 gap-8 sm:grid-cols-2 sm:gap-5">
          <Select
            list={STATES}
            value={formHandler?.values.state}
            onSelect={(value) => {
              formHandler?.setFieldValue('city', '');
              formHandler?.setFieldValue('state', value);
            }}
            disabled={formHandler?.isSubmitting}
            errorMessage={
              formHandler?.touched.state && formHandler?.errors.state
                ? formHandler?.errors.state
                : ''
            }
            label={
              <>
                State
                <span className="text-brand-posh-pink">*</span>
              </>
            }
            placeholder="Select state"
            otherClasses={{
              container: 'w-full mt-0',
              listContainer: 'bottom-18 top-auto',
            }}
          />

          <Input
            onBlur={formHandler?.handleBlur}
            label={
              <>
                City
                <span className="text-brand-posh-pink">*</span>
              </>
            }
            errorMessage={
              formHandler?.touched.city && formHandler?.errors.city
                ? formHandler?.errors.city
                : ''
            }
            placeholder="Select city"
            disabled={formHandler?.isSubmitting}
            value={formHandler?.values.city}
            type="text"
            onChange={formHandler?.handleChange}
            name="city"
            otherClasses={{ container: 'w-full' }}
          />
        </div>
        <div className="mb-8 grid w-full grid-cols-1 gap-8 sm:grid-cols-2 sm:gap-5">
          <Select
            list={[
              {
                label: 'Non Government',
                value: '1',
              },
              {
                label: 'State Government',
                value: '2',
              },
              {
                label: 'Local Government',
                value: '3',
              },
            ]}
            value={formHandler?.values.establishment_type}
            onSelect={(value) => {
              formHandler?.setFieldValue('establishment_type', value);
            }}
            disabled={formHandler?.isSubmitting}
            errorMessage={
              formHandler?.touched.establishment_type &&
              formHandler?.errors.establishment_type
                ? formHandler?.errors.establishment_type
                : ''
            }
            label={
              <>
                Establishment Type
                <span className="text-brand-posh-pink">*</span>
              </>
            }
            placeholder="Select establishment type"
            otherClasses={{
              container: 'w-full',
              listContainer: 'bottom-18 top-auto',
            }}
          />
          <Select
            list={[
              {
                label: 'less than 20 employees',
                value: '1',
              },
              {
                label: '20–99 employees',
                value: '21',
              },
              {
                label: '100–249 employees',
                value: '22',
              },
              {
                label: '250+ employees',
                value: '3',
              },
            ]}
            value={formHandler?.values.size}
            onSelect={(value) => {
              formHandler?.setFieldValue('size', value);
            }}
            disabled={formHandler?.isSubmitting}
            errorMessage={
              formHandler?.touched.size && formHandler?.errors.size
                ? formHandler?.errors.size
                : ''
            }
            label={
              <>
                Size
                <span className="text-brand-posh-pink">*</span>
              </>
            }
            placeholder="Select size"
            otherClasses={{
              container: 'w-full',
              listContainer: 'bottom-18 top-auto',
            }}
          />
        </div>
        <div className="mb-8 grid w-full grid-cols-1 gap-8 sm:grid-cols-2 sm:gap-5">
          <Input
            onBlur={formHandler?.handleBlur}
            label={
              <>
                Industry Description{' '}
                <span className="font-normal italic">
                  (e.g., Manufacture of motor truck trailers)
                </span>
                <span className="text-brand-posh-pink">*</span>
              </>
            }
            errorMessage={
              formHandler?.touched.industryDescription &&
              formHandler?.errors.industryDescription
                ? formHandler?.errors.industryDescription
                : ''
            }
            disabled={formHandler?.isSubmitting}
            value={formHandler?.values.industryDescription}
            type="text"
            placeholder="Enter industry description"
            onChange={formHandler?.handleChange}
            name="industryDescription"
            otherClasses={{ container: 'w-full' }}
          />
          <Input
            onBlur={formHandler?.handleBlur}
            label={
              <>
                North American Industrial Classification (NAICS){' '}
                <span className="font-normal italic">(e.g., 336212)</span>
                <span className="text-brand-posh-pink">*</span>
              </>
            }
            errorMessage={
              formHandler?.touched.classification &&
              formHandler?.errors.classification
                ? formHandler?.errors.classification
                : ''
            }
            disabled={formHandler?.isSubmitting}
            value={formHandler?.values.classification}
            type="number"
            placeholder="Enter industrial classification"
            onChange={formHandler?.handleChange}
            name="classification"
            otherClasses={{ container: 'w-full' }}
          />
        </div>
        <Input
          onBlur={formHandler?.handleBlur}
          label={
            <>
              Zip
              <span className="text-brand-posh-pink">*</span>
            </>
          }
          errorMessage={
            formHandler?.touched.zip && formHandler?.errors.zip
              ? formHandler?.errors.zip
              : ''
          }
          disabled={formHandler?.isSubmitting}
          value={formHandler?.values.zip}
          type="number"
          placeholder="Enter zip"
          onChange={formHandler?.handleChange}
          name="zip"
          otherClasses={{ container: 'w-full' }}
        />

        {editEstablishment ? (
          <div className="mt-8 flex flex-col-reverse gap-15 md:grid md:grid-cols-2 md:gap-6 lg:mt-12">
            <Button
              variant="secondary"
              type="button"
              size={sm}
              onClick={() => {
                handleClose();
              }}
              disable={formHandler?.isSubmitting}
              otherClasses="text-brand-posh-pink hover:border-brand-posh-pink hover:text-brand-posh-pink"
            >
              Cancel
            </Button>
            <Button
              loading={formHandler?.isSubmitting}
              disable={
                formHandler?.values?.establishmentName ===
                  formHandler?.initialValues?.establishmentName &&
                formHandler?.values?.street ===
                  formHandler?.initialValues?.street &&
                formHandler?.values?.city ===
                  formHandler?.initialValues?.city &&
                formHandler?.values?.state ===
                  formHandler?.initialValues?.state &&
                formHandler?.values?.establishment_type ===
                  formHandler?.initialValues?.establishment_type &&
                formHandler?.values?.size ===
                  formHandler?.initialValues?.size &&
                formHandler?.values?.zip === formHandler?.initialValues?.zip &&
                formHandler?.values?.industryDescription ===
                  formHandler?.initialValues?.industryDescription &&
                formHandler?.values?.classification ===
                  formHandler?.initialValues?.classification
              }
              type="submit"
              size={sm}
            >
              Update
            </Button>
          </div>
        ) : (
          <Button
            loading={formHandler?.isSubmitting}
            disable={formHandler?.isSubmitting}
            type="submit"
            otherClasses="mt-9"
            size={sm}
          >
            Create
          </Button>
        )}
      </form>
    </div>
  );
};

export default CreateEstablishmentModal;
